import { defineMessages, type MessageDescriptor } from 'react-intl-next';

import { type RuleType } from '../../types';

const messages = defineMessages({
	addIcon: {
		id: 'eoc.notifications.rules.add-icon.no-translate',
		defaultMessage: 'Add rule',
		description: 'Button label to indicate it is used for adding a new notification rule.',
	},
	'New Alert': {
		id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
		defaultMessage: 'New alert',
		description: 'The title of new alert notifications',
	},
	'Schedule Start': {
		id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
		defaultMessage: 'Schedule start',
		description: 'The title of schedule start notifications',
	},
	'Schedule End': {
		id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
		defaultMessage: 'Schedule end',
		description: 'The title of schedule end notifications',
	},
	'Acknowledged Alert': {
		id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
		defaultMessage: 'Acknowledged alert',
		description: 'The title of acknowledged alert notifications',
	},
	'Closed Alert': {
		id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
		defaultMessage: 'Closed alert',
		description: 'The title of closed alert notifications',
	},
	'Assigned Alert': {
		id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
		defaultMessage: 'Assigned alert',
		description: 'The title of assigned alert notifications',
	},
	'Add Note': {
		id: 'eoc.notifications.ui.notifications.add-note.no-translate',
		defaultMessage: 'Add note',
		description: 'The title of add note notifications',
	},
	'Incoming Call Routing': {
		id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
		defaultMessage: 'Incoming Call Routing',
		description: 'The title of incoming call rounting notifications',
	},
	addButtonTooltip: {
		id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
		defaultMessage: 'A role-based notification is in effect, so adding more rules isn’t possible.',
		description:
			'The message to be shown when user tries to add a rule but there is a role-based notification',
	},
} as Record<RuleType | string, MessageDescriptor>);

export default messages;
